import DeletePurchaseOrder from "@/v2/api/purchase-order/Delete";
import DeleteButton from "../general/Delete";

export default function PurchaseOrderDeleteButton({
    id,
    isInside = false,
}: {
    id: string;
    isInside?: boolean;
}) {
    return (
        <DeleteButton
            id={id}
            queryKey={["purchase-order"]}
            deleteFn={DeletePurchaseOrder}
            title="Delete Purchase Order"
            description="Are you sure you want to delete this purchase order record? This action cannot be undone. Click delete to confirm."
            successTitle="Purchase Order Deleted Successfully"
            isInside={isInside}
        />
    );
}
